enum CartItemType {
  Product = 'product',
  Coupon = 'coupon',
}

export default CartItemType;
